module.exports = __webpack_public_path__ + "static/media/logo.e17c059f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assests/images/logo.png
// module id = 111
// module chunks = 3